import largeCoin from "@assets/images/Group-1410087714@2x.png";
import barcodeGraphic from "@assets/images/Group-14100877141@2x.png";
import headerIcon from "@assets/images/Group-1410087716.svg";
import smallCoin from "@assets/images/Group-1410087715.svg";
import mergedCards from "@assets/images/merged-asset-1@2x.png";
import creditCard from "@assets/images/Frame-1618869501@2x.png";
import { Reveal } from "@components/ui";

function RefundIllustration() {
  return (
    <div className="hidden lg:flex flex-col items-start relative min-w-[297px] max-w-[356px] shrink-0">
      {/* Main row: coin + phone + small coin */}
      <div className="self-stretch flex items-end justify-center pl-2.5 gap-[23.8px]">
        {/* Large coin + Phone group */}
        <div className="flex-1 flex items-start gap-[12.5px] max-w-[252px]">
          <div className="pt-[52.7px]">
            <img src={largeCoin} alt="" className="w-[70.1px] h-[70.1px] object-cover" loading="lazy" />
          </div>
          <div className="flex-1 rounded-[10.1px] bg-[#14233c] overflow-hidden flex flex-col items-center py-[9.3px] px-[7.6px]">
            <div className="w-full rounded-[5px] overflow-hidden bg-[#fff9f9] flex flex-col items-center py-[7.6px] px-[10px] gap-[16.9px]">
              <div className="w-[122.9px] h-[45px] relative">
                <img src={headerIcon} alt="" className="absolute top-[0.4px] left-[114.3px] w-[9.3px] h-[4.8px]" />
                <span className="absolute top-[20.1px] left-[26.2px] text-[20.1px] uppercase font-extrabold text-black font-albert-sans">
                  Failed
                </span>
              </div>
              <img src={barcodeGraphic} alt="" className="w-[78.1px] h-[36.2px] object-cover" loading="lazy" />
              <div className="self-stretch flex flex-col items-center pt-[23.1px] pb-[7.8px] gap-[9px]">
                {[0, 1, 2].map((row) => (
                  <div key={row} className="self-stretch flex items-start justify-center gap-[10.5px]">
                    {[0, 1, 2].map((col) => (
                      <div
                        key={col}
                        className={`h-[34px] w-[33.5px] rounded-[4.4px] ${
                          row === 2 && col === 2 ? "bg-[#d67b46]" : "bg-[#dcdcdc]"
                        }`}
                      />
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="pb-[53.5px]">
          <img src={smallCoin} alt="" className="w-[44.2px] h-[44.2px]" />
        </div>
      </div>
      <img src={mergedCards} alt="" className="absolute bottom-[17.5px] left-[2px] w-[115.9px] h-[68.8px] object-cover z-[1]" />
      <img src={creditCard} alt="" className="absolute bottom-[6.7px] left-[17px] w-[111.6px] h-[56.4px] object-contain z-[4]" loading="lazy" />
      <div className="self-stretch h-[7.2px] rounded-[50%] bg-[rgba(217,217,217,0.3)]" />
    </div>
  );
}

export function RefundsSection() {
  return (
    <section className="w-full bg-[#f9f9fb] overflow-hidden py-10 md:py-14 lg:py-[59px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-[42px]">
        {/* Text Content */}
        <Reveal direction="up" className="flex-1 min-w-0 lg:max-w-[970px]">
          <div className="flex flex-col items-start gap-5">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase">
              Refunds
            </span>
            <h2 className="self-stretch text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1]">
              Refunds &amp; Deposits
            </h2>
            <p className="self-stretch text-[14px] md:text-base lg:text-[28px] tracking-[-0.04em] text-[#62636c] font-albert-sans leading-[1.4]">
              Refunds on deposits or overpayments are processed within 7–10
              working days. For refund requests, please contact our billing team
              at help@gasis.ae with your account details and proof of payment.
            </p>

            {/* Info items */}
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mt-2">
              <div className="flex items-center gap-2.5 px-4 py-2.5 rounded-[12px] bg-white border border-[#e8e9ed]">
                <div className="w-8 h-8 rounded-full bg-[#122d63]/8 flex items-center justify-center">
                  <svg viewBox="0 0 16 16" fill="none" className="w-4 h-4">
                    <circle cx="8" cy="8" r="6.5" stroke="#122d63" strokeWidth="1.2" />
                    <path d="M8 5v3l2 1" stroke="#122d63" strokeWidth="1.2" strokeLinecap="round" />
                  </svg>
                </div>
                <span className="text-[13px] md:text-[15px] font-medium tracking-[-0.02em] text-[#1e1f24] font-albert-sans">7-10 working days</span>
              </div>
              <div className="flex items-center gap-2.5 px-4 py-2.5 rounded-[12px] bg-white border border-[#e8e9ed]">
                <div className="w-8 h-8 rounded-full bg-[#f24d2b]/8 flex items-center justify-center">
                  <svg viewBox="0 0 16 16" fill="none" className="w-4 h-4">
                    <path d="M2 12l2.5-2.5M14 4l-2.5 2.5M6 10l4-4" stroke="#f24d2b" strokeWidth="1.2" strokeLinecap="round" />
                    <rect x="1" y="11" width="4" height="4" rx="1" stroke="#f24d2b" strokeWidth="1.2" />
                    <rect x="11" y="1" width="4" height="4" rx="1" stroke="#f24d2b" strokeWidth="1.2" />
                  </svg>
                </div>
                <span className="text-[13px] md:text-[15px] font-medium tracking-[-0.02em] text-[#1e1f24] font-albert-sans">help@gasis.ae</span>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Illustration - Desktop only */}
        <Reveal direction="right" delay={200}>
          <RefundIllustration />
        </Reveal>
      </div>
    </section>
  );
}
